import '../page1-com/title.css'
export default function Title(){
    return(
        <>
        <div className="h"><div className="head">
        </div></div>
        <div className="t">
        <h3 className='t-1'>Concentrated spices (powder)</h3>
        </div>
        </>
    )
}